/**
 * DebtCategory — muddatli qarz kategoriyalari (Feature B).
 *
 * Har kategoriya `termDays` (kun) bilan. Qarzga biriktirilsa:
 *   dueDate = debtDate + termDays
 * Misol: kategoriya "10 kun", qarz sanasi 29.05.2026 → muddat 08.06.2026.
 * Mavjud qarzlarga ham qo'llaniladi (tahrirlashda qayta hisoblanadi).
 */
import { z } from 'zod';
export const createDebtCategorySchema = z.object({
    name: z.string().min(1, 'Nom kerak').max(100),
    termDays: z.coerce.number().int().min(1, 'Kamida 1 kun').max(3650, "10 yildan ko'p bo'lmasin"),
});
export const updateDebtCategorySchema = createDebtCategorySchema.partial();
//# sourceMappingURL=debt-category.schema.js.map